import styled from '@emotion/styled';

export const MainBlock = styled.div`
  padding: 24px 24px 0 24px;
`;
